;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import Link from "next/link"
import get from "lodash/get"
import { isPayPerSession } from "../../../../lib/pricing"
import isConsultRequired from "../../../../lib/cohort/isConsultRequired"
import { Cohort, Pricing } from "../types"

type Props = {
  cohortId: number | null
  cohort: Cohort
  latestPricing: Pricing
  isLoggedIn: boolean
  requiresPayment?: boolean
  handleCheckoutButtonClick?: () => Promise<void>
}

export default function CheckoutButtonSection({
  cohortId: _cohortId,
  cohort,
  latestPricing,
  isLoggedIn: _isLoggedIn,
  requiresPayment: _requiresPayment,
  handleCheckoutButtonClick: _handleCheckoutButtonClick,
}: Props) {
  const isPayPerSessionValue = isPayPerSession({ paymentObj: latestPricing })
  const consultRequired = isConsultRequired(cohort)
  const onPlatform = get(latestPricing, "onPlatform", false)

  const _buttonText = !onPlatform
    ? "Reserve seat"
    : consultRequired
      ? isPayPerSessionValue
        ? "Reserve & pay per session"
        : "Save my seat"
      : "Join now"

  return (
    <div className="flex flex-col justify-center items-center pb-[33px]">
      <div className="text-[16px] text-[#AAAAAA] max-w-[346px]">
        Send message to therapist to join group{" "}
        <Link
          href="/policies/terms-of-use"
          target={"_blank"}
          className="text-[#AAAAAA]"
        >
          Terms of Use
        </Link>
        .
      </div>
    </div>
  )
}
